<template>
    <div :id="chartId"></div>
</template>

<script>
import * as d3 from "d3";

    export default {
        props: {
            chartId: {
                type: String
            },
            seriesData: {
                type: Array
            }
        },
        methods: {
            initiateBoxPlot() {
                const SVG_WIDTH = 350
                const SVG_HEIGHT = 250
                // set the dimensions and margins of the graph
                var margin = {top: 20, right: 20, bottom: 20, left: 20},
                    width = SVG_WIDTH - margin.left - margin.right,
                    height = SVG_HEIGHT - margin.top - margin.bottom;

                // append the svg object to the body of the page
                var svg = d3.select(`#${this.chartId}`)
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr("transform",
                        "translate(" + margin.left + "," + margin.top + ")");

                // Assign Data
                let q1 = this.seriesData[0]
                let median = this.seriesData[1]
                let q3 = this.seriesData[2]
                let min = this.seriesData[3]
                let max = this.seriesData[4]

                 // a few features for the box
                var box_width = 24
                var center = (width + 20) / 2 

                // Show the X scale
                var xscale = d3.scaleBand()
                .domain(["A"])
                .range([10, 300]); 

                // Show the Y scale
                var yscale = d3.scaleLinear()
                .domain([d3.min(this.seriesData), d3.max(this.seriesData)])
                .range([height, 0]);

                var x_axis = d3.axisBottom().scale(xscale);
                var y_axis = d3.axisLeft().scale(yscale);

                svg.append("g")
                    .attr("transform", "translate(10, 1)")
                    .call(y_axis);
                
                var xAxisTranslate = height + 5;
                
                svg.append("g")
                    .attr("transform", "translate(10, " + xAxisTranslate  +")")
                    .call(x_axis)

                // Show the main vertical line
                svg
                .append("line")
                .attr("x1", center)
                .attr("x2", center)
                .attr("y1", yscale(min) )
                .attr("y2", yscale(max) )
                .attr("stroke", "#0e84ff")

                // Show the box
                svg
                .append("rect")
                .attr("x", center - box_width/2)
                .attr("y", yscale(q3) )
                .attr("height", (yscale(q1)-yscale(q3)) )
                .attr("width", box_width )
                .attr("stroke", "#0e84ff")
                .style("fill", "#ffffff")

                // show median, min and max horizontal lines
                svg
                .selectAll("toto")
                .data([min, median, max])
                .enter()
                .append("line")
                .attr("x1", center-box_width/2)
                .attr("x2", center+box_width/2)
                .attr("y1", function(d){ return(yscale(d))} )
                .attr("y2", function(d){ return(yscale(d))} )
                .attr("stroke", "#0e84ff")
            }
        },
        mounted() {
            this.initiateBoxPlot()
        }
    }
</script>

<style lang="css" scoped>
.mini-chart {
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/Analytics/ExpandMiniBoxPlotChart.vue